import tlds from 'tlds';
import linkifyIt from 'linkify-it';
import EditorUtils from '../draft-js-plugins-utils/src';
import { EditorState } from 'draft-js';

const linkify = linkifyIt();
linkify.tlds(tlds);

export const fromBombBomb = (url: string): boolean => {
  return url.startsWith('https://content.bombbomb.com') || url.startsWith('https://vid.us');
};

export const isBomBombVideoSelected = (editorState: EditorState): boolean => {
  let selected = false;
  const hasImageSelected = EditorUtils.hasEntity(editorState, 'IMAGE');
  const imageInstance = EditorUtils.getCurrentEntity(editorState);
  const link =
    imageInstance && imageInstance.getData().src
      ? linkify.match(imageInstance.getData().src)
      : null;
  const src = link?.[0]?.url ?? '';
  const isBombBombVideo = fromBombBomb(src);
  if (hasImageSelected && typeof link !== 'undefined' && isBombBombVideo) {
    selected = true;
  }
  return selected;
};
